import { renderRoutes } from "utils/route";
import getRoutes, { protectRoutes } from "./routes";
import React, { Suspense, useMemo } from "react";
import { history } from "./store";
import PageLoading from "components/base/PageLoading";
import {
  useIsAdmin,
  usePermissions,
  useUserType,
} from "components/CurrentUser/hooks";
import { Router, useLocation } from "react-router-dom";
import ScrollToTop from "components/base/ScrollToTop";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  integrations: [
    new Integrations.BrowserTracing({
      // Can also use reactRouterV3Instrumentation or reactRouterV4Instrumentation
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    }),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

const AppRoute = () => {
  const routes = useMemo(getRoutes, []);

  const permissions = usePermissions();

  const isAdmin = useIsAdmin();

  const userType = useUserType();

  const protectedRoute = useMemo(
    () => protectRoutes(routes, permissions, isAdmin, userType),
    [routes, permissions, isAdmin, userType]
  );

  return (
    <Router history={history}>
      <ScrollToTop />
      <Suspense fallback={<PageLoading loading={true} />}>
        {renderRoutes(protectedRoute)}
      </Suspense>
    </Router>
  );
};

export default AppRoute;
